import React, { useEffect, useRef } from 'react';

import AboutUsIcon from '../../assets/images/header/about-us.svg';

/** images */
import ContactUsIcon from '../../assets/images/header/contact-us.svg';

const AmazonSidebar = ({ handleDashboardClick, handleProfileClick }) => {
  const sidebarRef = useRef(null);

  const handleCloseSidebar = (event) => {
    const toggleMenuButton = document.getElementsByClassName('toggle-menu-button')[0];
    const targetEl = event.target;
    if (
      sidebarRef.current &&
      !sidebarRef.current.contains(targetEl) &&
      !toggleMenuButton.contains(targetEl)
    ) {
      sidebarRef.current.classList.remove('amazon-sidebar--show');
    }
  };

  const handleClickContact = () => {
    window.open('https://lendistry.com/contact/');
  };

  const handleClickAboutUs = () => {
    window.open('https://lendistry.com/about/');
  };

  useEffect(() => {
    document.addEventListener('click', handleCloseSidebar, true);
    return () => {
      document.removeEventListener('click', handleCloseSidebar, true);
    };
  });

  return (
    <div className="amazon-sidebar" ref={sidebarRef}>
      <ul className="nav-list border-bottom">
        <li className="nav-list__item">
          <div onClick={handleDashboardClick}>
            <span>Dashboard</span>
          </div>
        </li>
        <li className="nav-list__item">
          <div onClick={handleProfileClick}>
            <span>Profile</span>
          </div>
        </li>
      </ul>
      <div className="amazon-sidebar__bottom">
        <ul className="nav-list">
          <li
            className="nav-list__item"
            onClick={() => {
              handleClickContact();
            }}
          >
            <div className="d-flex align-items-center">
              <img src={ContactUsIcon} alt="contact-us" />
              <span>Contact Us</span>
            </div>
          </li>
          <li
            className="nav-list__item"
            onClick={() => {
              handleClickAboutUs();
            }}
          >
            <div className="d-flex align-items-center">
              <img src={AboutUsIcon} alt="about-us" />
              <span>About Us</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AmazonSidebar;
